import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {openModal} from '../../actions/ModalActions';
import ConfirmDeleteScheduleModal from '../schedule/ConfirmDeleteModal';
import { openWizardForScheduledCall } from '../schedule-wizard/logActivityReducer';
import ScheduleModal from '../ScheduleModal';

import ActivityTimelineItem from './items/ActivityTimelineItem';
import EmailTimelineItem from './items/EmailTimelineItem';
import MeetingTimelineItem from './items/MeetingTimelineItem';
import NoteTimelineItem from './items/NoteTimelineItem';
import PhonecallTimelineItem from './items/PhonecallTimelineItem';
import ScheduleTimelineItem from './items/ScheduleTimelineItem';
import UservoiceNoteTimelineItem from './items/UservoiceNoteTimelineItem';
import UservoiceQueryTimelineItem from './items/UservoiceQueryTimelineItem';
import UservoiceResponseTimelineItem from './items/UservoiceResponseTimelineItem';

@connect(
    (state, props) => ({createdByUser : state.users.users.find(u => u.id == props.createdBy)}),
    {openModal, openWizardForScheduledCall}
)
export default class TimelineItemContainer extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            isBubbleExpanded: false,
            bubbleStyle: {maxHeight: '150px'},
            showMoreStyle: {top: '120px'}
        };
    }

    confirmDelete(e){
        e.preventDefault();
        this.props.openModal(ConfirmDeleteScheduleModal, {scheduleId: this.props.id, type: this.props.type});
    }

    editSchedule(phoneCall, e) {
        if(e) {
            e.preventDefault();
        }


        var props = {
            ...phoneCall,
            eventType: 'phonecall',
            scheduleId: phoneCall.id,
            hideEventTypes: true,
            clientId: phoneCall.clientId,
            assignedUserIds: [phoneCall.assignedUser.id]
        };

        this.props.openModal(ScheduleModal, props);
    }

    toggleBubble(e){
        var isNowExpanded = ! this.state.isBubbleExpanded;

        this.setState({
            isBubbleExpanded: isNowExpanded,
            bubbleStyle: {
                maxHeight: isNowExpanded ? '90000px' : '150px',
            }
        });

        this.forceUpdate();
    }

    eventComponentFromEvent(event) {
         var eventTypeComponentMap = {
            email: EmailTimelineItem,
            note: NoteTimelineItem,
            schedule: ScheduleTimelineItem,
            phonecall: PhonecallTimelineItem,
            meeting: MeetingTimelineItem,
            uservoicequery: UservoiceQueryTimelineItem,
            uservoiceresponse: UservoiceResponseTimelineItem,
            uservoicenote: UservoiceNoteTimelineItem,
            fergus_activity: ActivityTimelineItem
        };

        return eventTypeComponentMap[event.type];
    }

    render() {
        var { event } = this.props;
        var EventComponent = this.eventComponentFromEvent(event);
        
        return (
            <div className="clientTimeline__event__timeslot ">
                <EventComponent {...this.props} />     

                <div className="clientTimeline__timeLabel">
                    { moment(this.props.date).format("h:mma") }
                </div>
            </div>
        )
    }

}




// WEBPACK FOOTER //
// ./app/components/client-timeline/TimelineItemContainer.js